
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30.25 30.25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#000","stroke-width":".25","d":"M8.495 8.765c-.96 0-1.73.78-1.73 1.73v9.26c0 .95.77 1.73 1.73 1.73h13.26c.96 0 1.73-.78 1.73-1.73v-9.26c0-.95-.77-1.73-1.73-1.73zm13.26 13.36H8.495a2.37 2.37 0 01-2.37-2.37v-9.26c0-1.3 1.06-2.37 2.37-2.37h13.26c1.3 0 2.37 1.06 2.37 2.37v9.26c0 1.3-1.06 2.37-2.37 2.37z"}}),_c('path',{attrs:{"d":"M23.765 19.125h-17.3v1h17.3zm-15.27-8.72h1v-1.64h-1zm4.99-1.92h-1v2h1zm4 .08h-1v2h1zm4-.16h-1v2h1z"}}),_c('path',{attrs:{"d":"M9.495 21.625v-1.67h-1v1.67zm3.99-1.83h-1v2h1zm4 0h-1v2h1zm3-.06v2h1v-2zm-5.79-5.52v1.8l1.34-.93zm-.57 2.91v-4l3 1.95z"}}),_c('path',{attrs:{"d":"M15.125.765a14.37 14.37 0 00-14.36 14.36c0 7.92 6.44 14.36 14.36 14.36 7.92 0 14.36-6.44 14.36-14.36 0-7.92-6.44-14.36-14.36-14.36zm0 29.36c-8.27 0-15-6.73-15-15s6.73-15 15-15 15 6.73 15 15-6.73 15-15 15z","stroke":"#000","stroke-width":".25"}}),_c('path',{attrs:{"d":"M6.365 10.075v1h17.3v-1z"}})])
          )
        }
      }
    